import React from 'react';
import Wrapper from './styled';
import Tools from './Tools';

const Content = ({ tabRef, onScroll, showTransparency, toolToSave, setToolToSave, setTriggerWarning, toolExpanded, setToolExpanded }) => {
  return (
    <Wrapper ref={ tabRef } onScroll={ onScroll } showTransparency={ showTransparency }>
      <Tools toolToSave={ toolToSave } setToolToSave={ setToolToSave } setTriggerWarning={ setTriggerWarning } toolExpanded={ toolExpanded } setToolExpanded={ setToolExpanded } />
    </Wrapper>
  );
};

export default Content;
